<template>
  <a-modal
    title="题目详情"
    style="top: 20px"
    :width="800"
    v-model="visible"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    :maskClosable="false"
    :footer="false"
  >
    <div class="table-page-search-wrapper">
      <a-form layout="inline" :form="form">
        <a-row :gutter="16" style="margin-bottom: 60px">
          <a-col :span="22">
            <a-form-item label="题目" style="width: 100%; margin-bottom: 20px">
              <a-textarea v-model="mdl.title" disabled="disabled" />
            </a-form-item>
          </a-col>
        </a-row>

        <a-row :gutter="7">
          <a-col :span="7">
            <a-form-item label="A">
              <a-input v-model="answerList[0].A" disabled="disabled" />
            </a-form-item>
          </a-col>
          <a-col :span="7" v-if="mdl.answer == 'A'">
            <a-form-item> <a-input type="radio" checked disabled="disabled" /><label>正确答案标注</label> </a-form-item>
          </a-col>
          <a-col :span="7" v-if="mdl.answer != 'A'">
            <a-form-item>
              <a-input type="radio" disabled="disabled" />
            </a-form-item>
          </a-col>
        </a-row>

        <a-row :gutter="7">
          <a-col :span="7">
            <a-form-item label="B">
              <a-input v-model="answerList[1].B" disabled="disabled" />
            </a-form-item>
          </a-col>
          <a-col :span="7" v-if="mdl.answer == 'B'">
            <a-form-item> <a-input type="radio" checked disabled="disabled" /><label>正确答案标注</label> </a-form-item>
          </a-col>
          <a-col :span="7" v-if="mdl.answer != 'B'">
            <a-form-item>
              <a-input type="radio" disabled="disabled" />
            </a-form-item>
          </a-col>
        </a-row>

        <a-row :gutter="7">
          <a-col :span="7">
            <a-form-item label="C">
              <a-input v-model="answerList[2].C" disabled="disabled" />
            </a-form-item>
          </a-col>
          <a-col :span="7" v-if="mdl.answer == 'C'">
            <a-form-item> <a-input type="radio" checked disabled="disabled" /><label>正确答案标注</label> </a-form-item>
          </a-col>
          <a-col :span="7" v-if="mdl.answer != 'C'">
            <a-form-item>
              <a-input type="radio" disabled="disabled" />
            </a-form-item>
          </a-col>
        </a-row>

        <a-row :gutter="7">
          <a-col :span="7">
            <a-form-item label="D">
              <a-input v-model="answerList[3].D" disabled="disabled" />
            </a-form-item>
          </a-col>
          <a-col :span="7" v-if="mdl.answer == 'D'">
            <a-form-item> <a-input type="radio" checked disabled="disabled" /><label>正确答案标注</label> </a-form-item>
          </a-col>
          <a-col :span="7" v-if="mdl.answer != 'D'">
            <a-form-item>
              <a-input type="radio" disabled="disabled" />
            </a-form-item>
          </a-col>
        </a-row>

        <div></div>
      </a-form>
    </div>
  </a-modal>
</template>
<script>
import { ACCESS_TOKEN } from '@/store/mutation-types'
import pick from 'lodash.pick'
export default {
  name: 'examinationInfo',
  props: {},
  components: {},
  data() {
    return {
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN),
      },
      answerList: [],
      clientInfoPics: [],
      data: '',
      visible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      mdl: {},
      form: this.$form.createForm(this),
    }
  },
  beforeCreate() {},
  created() {},
  methods: {
    edit(record) {
      console.log('record', record)
      this.answerList = []
      this.answerList = record.options
      this.mdl = {}
      this.mdl = record
      this.visible = true
    },

    handleSubmit(e) {
      this.visible = false
    },
  },

  watch: {},
}
</script>
<style scoped>
.disEvents {
  pointer-events: none;
}
</style>
